/* ==========================================================================
   THE EON WEAR — Drop / Season collection
   Responsabilidades (encapsuladas por raíz [data-eon-drop-root]):
     - estado de desbloqueo Season 2 (solo flags en localStorage, nunca PII)
     - modal de desbloqueo (prenda: email · Season: email + teléfono)
     - envío real del lead a Klaviyo (Client API con clave PÚBLICA)
     - revelado de tarjetas / gate de PDP
     - quick add por talla (reutiliza <cart-drawer> de Dawn)
     - filtro / orden / vista móvil
   Compatible con el Theme Editor (shopify:section:load / unload).
   Eventos sin PII: eon:season2:{product,full}_unlock_{open,success}
   ========================================================================== */

(function () {
  "use strict";

  if (window.EONDrop) {
    window.EONDrop.initAll(document);
    return;
  }

  var STORAGE_ALL = "eon_s2_unlocked_all";
  var STORAGE_PRODUCTS = "eon_s2_unlocked_products";
  var STORAGE_VIEW = "eon_drop_view";
  var TEASER_ID = "eon-season-2";
  var KLAVIYO_ENDPOINT = "https://a.klaviyo.com/client/";
  var KLAVIYO_REVISION = "2025-01-15";
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var PHONE_RE = /^\+[1-9]\d{6,14}$/;
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  /* ------------------------------------------------------------------------
     Estado de desbloqueo (UX). No es persistencia del lead ni control de acceso.
     ------------------------------------------------------------------------ */
  var unlockState = {
    read: function (key) {
      try { return window.localStorage.getItem(key); } catch (e) { return null; }
    },
    write: function (key, value) {
      try { window.localStorage.setItem(key, value); } catch (e) { /* modo privado: solo dura la sesión */ }
    },
    isAll: function () {
      return this.read(STORAGE_ALL) === "true";
    },
    products: function () {
      try {
        var list = JSON.parse(this.read(STORAGE_PRODUCTS) || "[]");
        return Array.isArray(list) ? list : [];
      } catch (e) { return []; }
    },
    has: function (handle) {
      return this.isAll() || (!!handle && this.products().indexOf(handle) !== -1);
    },
    unlockAll: function () {
      this.write(STORAGE_ALL, "true");
    },
    unlockProduct: function (handle) {
      if (!handle) return;
      var list = this.products();
      if (list.indexOf(handle) === -1) list.push(handle);
      this.write(STORAGE_PRODUCTS, JSON.stringify(list));
    },
  };

  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
  }

  /* ------------------------------------------------------------------------
     Klaviyo Client API — solo clave pública. El éxito depende de la
     suscripción a la lista; el evento de metadatos es best-effort.
     ------------------------------------------------------------------------ */
  function klaviyoPost(path, publicKey, payload) {
    return fetch(KLAVIYO_ENDPOINT + path + "/?company_id=" + encodeURIComponent(publicKey), {
      method: "POST",
      headers: {
        "Content-Type": "application/vnd.api+json",
        Accept: "application/vnd.api+json",
        revision: KLAVIYO_REVISION,
      },
      body: JSON.stringify(payload),
    }).then(function (response) {
      if (!response.ok) {
        var error = new Error("klaviyo_" + response.status);
        error.code = "submit";
        throw error;
      }
      return response;
    });
  }

  function submitLead(config, lead) {
    var listId = lead.mode === "full" ? config.listFull : config.listProduct;
    if (!config.klaviyoKey || !listId) {
      var notConfigured = new Error("not_configured");
      notConfigured.code = "not_configured";
      return Promise.reject(notConfigured);
    }

    var subscriptions = { email: { marketing: { consent: "SUBSCRIBED" } } };
    var profile = { email: lead.email, subscriptions: subscriptions };
    if (lead.phone && config.sms) {
      profile.phone_number = lead.phone;
      subscriptions.sms = { marketing: { consent: "SUBSCRIBED" } };
    }

    var source =
      lead.mode === "full"
        ? "EON · Season 2 · Full drop early access"
        : "EON · Season 2 · Product unlock" + (lead.handle ? " · " + lead.handle : "");

    return klaviyoPost("subscriptions", config.klaviyoKey, {
      data: {
        type: "subscription",
        attributes: {
          custom_source: source,
          profile: { data: { type: "profile", attributes: profile } },
        },
        relationships: { list: { data: { type: "list", id: listId } } },
      },
    }).then(function () {
      var eventProfile = { email: lead.email };
      if (lead.phone) eventProfile.phone_number = lead.phone;
      return klaviyoPost("events", config.klaviyoKey, {
        data: {
          type: "event",
          attributes: {
            properties: {
              brand: "EON",
              season: "season-2",
              unlock_type: lead.mode === "full" ? "full_drop" : "product",
              interest: lead.mode === "full" ? "season_2_full_drop" : "season_2_" + (lead.handle || "teaser"),
              product_handle: lead.handle || null,
              page: window.location.pathname,
            },
            time: new Date().toISOString(),
            metric: { data: { type: "metric", attributes: { name: "EON Season 2 Unlock" } } },
            profile: { data: { type: "profile", attributes: eventProfile } },
          },
        },
      }).catch(function () { /* metadatos opcionales: el lead ya está guardado */ });
    });
  }

  function normalizePhone(raw, countryCode) {
    var value = String(raw || "").replace(/[\s().\-/]/g, "");
    if (!value) return null;
    if (value.indexOf("00") === 0) value = "+" + value.slice(2);
    if (value.charAt(0) !== "+") value = String(countryCode || "") + value.replace(/^0+/, "");
    return PHONE_RE.test(value) ? value : null;
  }

  /* ------------------------------------------------------------------------
     Scroll lock con contador (modal + drawer de filtros + gate)
     ------------------------------------------------------------------------ */
  var scrollLocks = 0;
  function lockScroll() {
    scrollLocks += 1;
    document.documentElement.classList.add("eon-drop-scroll-lock");
  }
  function unlockScroll() {
    scrollLocks = Math.max(0, scrollLocks - 1);
    if (scrollLocks === 0) document.documentElement.classList.remove("eon-drop-scroll-lock");
  }

  /* Focus trap: devuelve una función que lo libera */
  function trapFocus(container, onEscape) {
    function onKeydown(event) {
      if (event.key === "Escape" && onEscape) {
        event.preventDefault();
        onEscape();
        return;
      }
      if (event.key !== "Tab") return;
      var nodes = Array.prototype.filter.call(container.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (event.shiftKey && (document.activeElement === first || !container.contains(document.activeElement))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
    document.addEventListener("keydown", onKeydown);
    return function release() {
      document.removeEventListener("keydown", onKeydown);
    };
  }

  /* ------------------------------------------------------------------------
     Raíz de drop (sección de colección o gate de PDP)
     ------------------------------------------------------------------------ */
  function DropRoot(root) {
    this.root = root;
    var configEl = root.querySelector("[data-eon-drop-config]");
    try { this.config = JSON.parse(configEl ? configEl.textContent : "{}"); } catch (e) { this.config = {}; }
    this.strings = this.config.strings || {};
    this.isGate = root.hasAttribute("data-eon-drop-gate");
    this.dialog = root.querySelector("[data-eon-drop-dialog]");
    this.form = root.querySelector("[data-eon-drop-form]");
    this.context = null;
    this.pending = false;
    this.releaseTrap = null;
    this.timers = [];
    this.ownsScrollLock = false;

    this.onClick = this.onClick.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onScroll = this.onScroll.bind(this);

    root.addEventListener("click", this.onClick);
    root.addEventListener("change", this.onChange);
    root.addEventListener("scroll", this.onScroll, true);
    if (this.form) this.form.addEventListener("submit", this.onSubmit);

    this.applyInitialState();
    this.restoreView();
  }

  DropRoot.prototype.later = function (fn, ms) {
    this.timers.push(window.setTimeout(fn, ms));
  };

  DropRoot.prototype.destroy = function () {
    this.root.removeEventListener("click", this.onClick);
    this.root.removeEventListener("change", this.onChange);
    this.root.removeEventListener("scroll", this.onScroll, true);
    if (this.form) this.form.removeEventListener("submit", this.onSubmit);
    this.timers.forEach(window.clearTimeout);
    if (this.releaseTrap) this.releaseTrap();
    if (this.releaseFiltersTrap) this.releaseFiltersTrap();
    if (this.ownsScrollLock) unlockScroll();
    if (this.filtersOpen) unlockScroll();
    if (this.isGate) document.documentElement.classList.remove("eon-drop-scroll-lock");
    delete this.root.__eonDrop;
  };

  /* Llegada desde la Home (o enlace directo) a .../collections/x#eon-season-2 */
  DropRoot.prototype.openTeaserFromHash = function () {
    if (window.location.hash !== "#" + TEASER_ID) return;
    var tab = this.root.querySelector("[data-eon-drop-tab-teaser]");
    if (tab) this.showTeaser(tab, false);
  };

  DropRoot.prototype.applyInitialState = function () {
    var self = this;

    if (this.isGate) {
      if (this.root.hasAttribute("data-unlocked") || unlockState.has(this.root.getAttribute("data-handle"))) {
        this.root.setAttribute("data-unlocked", "");
        document.documentElement.classList.remove("eon-drop-scroll-lock");
        return;
      }
      // El script inline ya aplicó el bloqueo de scroll; lo registramos en el contador.
      scrollLocks += 1;
      this.ownsScrollLock = true;
      this.context = { mode: "product", handle: this.root.getAttribute("data-handle"), url: null, card: null };
      this.setMode(this.config.enableProduct === false && this.config.enableFull ? "full" : "product");
      this.releaseTrap = trapFocus(this.dialog, null);
      emit(this.context.mode === "full" ? "eon:season2:full_unlock_open" : "eon:season2:product_unlock_open", {
        handle: this.context.handle,
        source: "pdp_gate",
      });
      return;
    }

    this.openTeaserFromHash();
    if (!this.config.locked) return;
    if (unlockState.isAll()) {
      this.root.classList.add("is-unlocked-all");
      this.revealAll(false);
      return;
    }
    this.root.querySelectorAll(".eon-drop-card--locked[data-handle]").forEach(function (card) {
      if (unlockState.has(card.getAttribute("data-handle"))) self.revealCard(card, false);
    });
  };

  /* ---------------------------------------------------------------- clicks */
  DropRoot.prototype.onClick = function (event) {
    var target = event.target;
    var el;

    if ((el = target.closest("[data-eon-drop-unlock]"))) {
      event.preventDefault();
      this.openDialog(el.getAttribute("data-eon-drop-unlock"), el);
      return;
    }
    if ((el = target.closest("[data-eon-drop-close]"))) {
      event.preventDefault();
      this.closeDialog();
      return;
    }
    if ((el = target.closest("[data-eon-drop-back]"))) {
      if (this.config.designMode && this.isGate) {
        event.preventDefault();
        this.leaveGate();
      }
      return;
    }
    if ((el = target.closest("[data-eon-drop-switch]"))) {
      event.preventDefault();
      this.setMode("full");
      emit("eon:season2:full_unlock_open", { source: "switch" });
      var phone = this.root.querySelector("[data-eon-drop-phone]");
      if (phone) phone.focus();
      return;
    }
    if ((el = target.closest("[data-eon-drop-add]"))) {
      event.preventDefault();
      this.addToCart(el);
      return;
    }
    if ((el = target.closest("[data-eon-drop-bag]"))) {
      event.preventDefault();
      var card = el.closest(".eon-drop-card");
      var open = !card.classList.contains("is-sizes-open");
      card.classList.toggle("is-sizes-open", open);
      el.setAttribute("aria-expanded", String(open));
      if (open) {
        var firstSize = card.querySelector("button.eon-drop-card__size");
        if (firstSize) firstSize.focus();
      }
      return;
    }
    if ((el = target.closest("[data-eon-drop-tab-teaser]"))) {
      if (this.root.querySelector('[data-eon-drop-panel="teaser"]')) {
        event.preventDefault();
        this.showTeaser(el, true);
      }
      return;
    }
    if ((el = target.closest("[data-eon-drop-view]"))) {
      this.setView(el.getAttribute("data-eon-drop-view"), true);
      return;
    }
    if ((el = target.closest("[data-eon-drop-filters-open]"))) {
      this.openFilters(el);
      return;
    }
    if ((el = target.closest("[data-eon-drop-filters-close]"))) {
      this.closeFilters();
    }
  };

  DropRoot.prototype.onChange = function (event) {
    var select = event.target.closest("[data-eon-drop-sort]");
    if (select && select.form) select.form.submit();
  };

  /* Puntos del carrusel móvil */
  DropRoot.prototype.onScroll = function (event) {
    var track = event.target;
    if (!track || !track.hasAttribute || !track.hasAttribute("data-eon-drop-track")) return;
    var dots = track.closest(".eon-drop-card__visual").querySelectorAll(".eon-drop-card__dot");
    if (!dots.length || !track.clientWidth) return;
    var index = Math.round(track.scrollLeft / track.clientWidth);
    dots.forEach(function (dot, i) { dot.classList.toggle("is-active", i === index); });
  };

  /* ---------------------------------------------------------- panel teaser */
  DropRoot.prototype.showTeaser = function (tab, updateHash) {
    var teaser = this.root.querySelector('[data-eon-drop-panel="teaser"]');
    var main = this.root.querySelector('[data-eon-drop-panel="main"]');
    if (!teaser) return;
    this.root.querySelectorAll(".eon-drop-nav__link").forEach(function (link) {
      link.classList.remove("is-active");
      link.removeAttribute("aria-current");
    });
    tab.classList.add("is-active");
    tab.setAttribute("aria-current", "page");
    teaser.hidden = false;
    if (main) main.hidden = true;
    if (updateHash && window.history && window.history.replaceState) {
      window.history.replaceState(null, "", "#" + TEASER_ID);
    }
  };

  /* ---------------------------------------------------------------- vista */
  DropRoot.prototype.restoreView = function () {
    var saved = unlockState.read(STORAGE_VIEW);
    if (saved === "1" || saved === "2") this.setView(saved, false);
  };

  DropRoot.prototype.setView = function (cols, persist) {
    this.root.querySelectorAll("[data-eon-drop-grid]").forEach(function (grid) {
      grid.setAttribute("data-cols", cols);
    });
    this.root.querySelectorAll("[data-eon-drop-view]").forEach(function (btn) {
      btn.setAttribute("aria-pressed", String(btn.getAttribute("data-eon-drop-view") === cols));
    });
    if (persist) unlockState.write(STORAGE_VIEW, cols);
  };

  /* -------------------------------------------------------------- filtros */
  DropRoot.prototype.openFilters = function (trigger) {
    var self = this;
    var drawer = this.root.querySelector("[data-eon-drop-filters]");
    if (!drawer || this.filtersOpen) return;
    this.filtersOpen = true;
    this.filtersTrigger = trigger;
    drawer.hidden = false;
    lockScroll();
    window.requestAnimationFrame(function () {
      drawer.classList.add("is-open");
      var panel = drawer.querySelector('[role="dialog"]');
      if (panel) panel.focus();
    });
    this.releaseFiltersTrap = trapFocus(drawer, function () { self.closeFilters(); });
  };

  DropRoot.prototype.closeFilters = function () {
    var drawer = this.root.querySelector("[data-eon-drop-filters]");
    if (!drawer || !this.filtersOpen) return;
    this.filtersOpen = false;
    drawer.classList.remove("is-open");
    if (this.releaseFiltersTrap) this.releaseFiltersTrap();
    this.releaseFiltersTrap = null;
    unlockScroll();
    this.later(function () { drawer.hidden = true; }, 350);
    if (this.filtersTrigger) this.filtersTrigger.focus();
  };

  /* --------------------------------------------------------------- modal */
  DropRoot.prototype.setMode = function (mode) {
    if (!this.dialog) return;
    var s = this.strings;
    var full = mode === "full";
    if (this.context) this.context.mode = mode;
    this.dialog.setAttribute("data-mode", mode);
    this.setText("[data-eon-drop-title]", full ? s.fullHeading : s.productHeading);
    this.setText("[data-eon-drop-body]", full ? s.fullBody : s.productBody);
    this.setText("[data-eon-drop-submit]", full ? s.fullCta : s.productCta);

    var phoneGroup = this.dialog.querySelector("[data-eon-drop-phone-group]");
    var phone = this.dialog.querySelector("[data-eon-drop-phone]");
    var smsGroup = this.dialog.querySelector("[data-eon-drop-sms-group]");
    if (phoneGroup) phoneGroup.hidden = !full;
    if (phone) phone.required = full;
    if (smsGroup) smsGroup.hidden = !(full && this.config.sms);

    var switchBtn = this.dialog.querySelector("[data-eon-drop-switch]");
    if (switchBtn) switchBtn.hidden = full || !this.config.enableFull;
    this.clearErrors();
  };

  DropRoot.prototype.setText = function (selector, value) {
    var el = this.dialog.querySelector(selector);
    if (el && typeof value === "string" && value.length) el.textContent = value;
  };

  DropRoot.prototype.openDialog = function (mode, trigger) {
    var self = this;
    if (!this.dialog || !this.config.locked) return;
    if (mode === "product" && !this.config.enableProduct) mode = this.config.enableFull ? "full" : null;
    if (mode === "full" && !this.config.enableFull) mode = null;
    if (!mode) return;

    var card = trigger.closest("[data-eon-drop-card]");
    this.context = {
      mode: mode,
      handle: card ? card.getAttribute("data-handle") : null,
      url: card ? card.getAttribute("data-url") : null,
      card: card,
      trigger: trigger,
    };

    this.showView("form");
    this.setMode(mode);
    this.dialog.hidden = false;
    lockScroll();
    this.ownsScrollLock = true;
    window.requestAnimationFrame(function () {
      self.dialog.classList.add("is-open");
      var email = self.dialog.querySelector("[data-eon-drop-email]");
      if (email) email.focus({ preventScroll: true });
    });
    this.releaseTrap = trapFocus(this.dialog, function () { self.closeDialog(); });

    emit(mode === "full" ? "eon:season2:full_unlock_open" : "eon:season2:product_unlock_open", {
      handle: this.context.handle,
      source: "collection",
    });
  };

  DropRoot.prototype.closeDialog = function (afterSuccess) {
    var self = this;
    if (!this.dialog || this.dialog.hidden || this.isGate) return;
    this.dialog.classList.remove("is-open");
    if (this.releaseTrap) this.releaseTrap();
    this.releaseTrap = null;
    if (this.ownsScrollLock) {
      unlockScroll();
      this.ownsScrollLock = false;
    }
    this.later(function () {
      self.dialog.hidden = true;
      self.showView("form");
    }, 380);

    var trigger = this.context && this.context.trigger;
    if (!afterSuccess && trigger && document.contains(trigger)) trigger.focus();
  };

  DropRoot.prototype.showView = function (view) {
    var form = this.dialog.querySelector("[data-eon-drop-view-form]");
    var success = this.dialog.querySelector("[data-eon-drop-view-success]");
    if (form) form.hidden = view !== "form";
    if (success) success.hidden = view !== "success";
  };

  DropRoot.prototype.clearErrors = function () {
    this.dialog.querySelectorAll("[data-eon-drop-error]").forEach(function (el) { el.textContent = ""; });
    this.dialog.querySelectorAll('[aria-invalid="true"]').forEach(function (el) { el.removeAttribute("aria-invalid"); });
  };

  DropRoot.prototype.showError = function (key, message, field) {
    var el = this.dialog.querySelector('[data-eon-drop-error="' + key + '"]');
    if (el) el.textContent = message || "";
    if (field) field.setAttribute("aria-invalid", "true");
  };

  /* -------------------------------------------------------------- submit */
  DropRoot.prototype.onSubmit = function (event) {
    event.preventDefault();
    if (this.pending || !this.context) return;
    var self = this;
    var s = this.strings;
    var full = this.context.mode === "full";

    var emailInput = this.form.querySelector("[data-eon-drop-email]");
    var phoneInput = this.form.querySelector("[data-eon-drop-phone]");
    var countrySelect = this.form.querySelector("[data-eon-drop-country]");
    var consentEmail = this.form.querySelector("[data-eon-drop-consent-email]");
    var consentSms = this.form.querySelector("[data-eon-drop-consent-sms]");

    this.clearErrors();
    var firstInvalid = null;

    var email = String(emailInput.value || "").trim().toLowerCase();
    if (!EMAIL_RE.test(email)) {
      this.showError("email", s.errorEmail, emailInput);
      firstInvalid = firstInvalid || emailInput;
    }

    var phone = null;
    if (full) {
      phone = normalizePhone(phoneInput.value, countrySelect ? countrySelect.value : "");
      if (!phone) {
        this.showError("phone", s.errorPhone, phoneInput);
        firstInvalid = firstInvalid || phoneInput;
      }
    }

    var needsSms = full && this.config.sms;
    if (!consentEmail.checked || (needsSms && consentSms && !consentSms.checked)) {
      var missing = !consentEmail.checked ? consentEmail : consentSms;
      this.showError("consent", s.errorConsent, missing);
      firstInvalid = firstInvalid || missing;
    }

    if (firstInvalid) {
      firstInvalid.focus();
      return;
    }

    var submitBtn = this.form.querySelector("[data-eon-drop-submit]");
    var submitLabel = submitBtn.textContent;
    this.pending = true;
    submitBtn.disabled = true;
    submitBtn.textContent = s.sending || submitLabel;

    submitLead(this.config, { email: email, phone: phone, mode: this.context.mode, handle: this.context.handle })
      .then(function () {
        // Los datos personales no se conservan en el DOM ni en el almacenamiento.
        self.form.reset();
        self.onUnlockSuccess();
      })
      .catch(function (error) {
        self.showError("form", error && error.code === "not_configured" ? s.errorNotConfigured : s.errorSubmit);
        if (error && error.code === "not_configured" && window.console) {
          console.warn("[EON drop] Klaviyo no configurado: Ajustes del tema → EON · Season 2.");
        }
      })
      .then(function () {
        self.pending = false;
        submitBtn.disabled = false;
        submitBtn.textContent = submitLabel;
      });
  };

  DropRoot.prototype.onUnlockSuccess = function () {
    var self = this;
    var ctx = this.context;
    var full = ctx.mode === "full";

    if (full) unlockState.unlockAll();
    else unlockState.unlockProduct(ctx.handle);

    emit(full ? "eon:season2:full_unlock_success" : "eon:season2:product_unlock_success", {
      handle: full ? null : ctx.handle,
      source: this.isGate ? "pdp_gate" : "collection",
    });

    var successBody = this.dialog.querySelector("[data-eon-drop-success-body]");
    if (successBody) successBody.textContent = full ? this.strings.successFull : this.strings.successProduct;
    this.showView("success");
    var panel = this.dialog.querySelector("[data-eon-drop-panel-dialog]");
    if (panel) panel.focus({ preventScroll: true });

    var anim = Number(this.config.animMs) || 700;

    if (this.isGate) {
      this.later(function () { self.leaveGate(); }, 1100);
      return;
    }

    this.later(function () {
      self.closeDialog(true);
      if (full) {
        self.root.classList.add("is-unlocked-all");
        self.revealAll(true);
        broadcastUnlockAll(self.root);
      } else if (ctx.card) {
        var link = self.revealCard(ctx.card, true);
        if (link) link.focus({ preventScroll: true });
        if (self.config.redirect && ctx.url) {
          self.later(function () { window.location.href = ctx.url; }, anim + 250);
        }
      }
    }, 1100);
  };

  DropRoot.prototype.leaveGate = function () {
    var self = this;
    if (this.releaseTrap) this.releaseTrap();
    this.releaseTrap = null;
    this.root.classList.add("is-leaving");
    this.later(function () {
      self.root.setAttribute("data-unlocked", "");
      if (self.ownsScrollLock) {
        unlockScroll();
        self.ownsScrollLock = false;
      }
      document.documentElement.classList.remove("eon-drop-scroll-lock");
    }, Number(this.config.animMs) || 700);
  };

  /* -------------------------------------------------------------- reveal */
  DropRoot.prototype.revealCard = function (card, animate) {
    var template = card.querySelector("template[data-eon-drop-reveal]");
    if (!template) return null;
    var fragment = template.content.cloneNode(true);
    card.classList.remove("eon-drop-card--locked");
    card.textContent = "";
    card.appendChild(fragment);
    if (animate) {
      card.classList.add("is-revealing");
      this.later(function () { card.classList.remove("is-revealing"); }, (Number(this.config.animMs) || 700) + 100);
    }
    return card.querySelector(".eon-drop-card__info");
  };

  DropRoot.prototype.revealAll = function (animate) {
    var self = this;
    var cards = this.root.querySelectorAll(".eon-drop-card--locked[data-handle]");
    Array.prototype.forEach.call(cards, function (card, i) {
      if (animate) self.later(function () { self.revealCard(card, true); }, i * 70);
      else self.revealCard(card, false);
    });
  };

  /* ------------------------------------------------------------ quick add */
  DropRoot.prototype.addToCart = function (button) {
    var self = this;
    if (button.classList.contains("is-loading")) return;
    var card = button.closest(".eon-drop-card");
    var status = card ? card.querySelector("[data-eon-drop-status]") : null;
    var cartDrawer = document.querySelector("cart-drawer");
    var formData = new FormData();
    formData.append("id", button.getAttribute("data-eon-drop-add"));
    formData.append("quantity", "1");

    var hasDrawer = cartDrawer && typeof cartDrawer.renderContents === "function";
    if (hasDrawer && typeof cartDrawer.getSectionsToRender === "function") {
      formData.append("sections", cartDrawer.getSectionsToRender().map(function (s) { return s.id; }));
      formData.append("sections_url", window.location.pathname);
      if (typeof cartDrawer.setActiveElement === "function") cartDrawer.setActiveElement(button);
    } else {
      formData.append("sections", "cart-icon-bubble");
    }

    button.classList.add("is-loading");
    if (status) status.textContent = "";

    var addUrl = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : "/cart/add") + ".js";
    fetch(addUrl, { method: "POST", headers: { Accept: "application/json" }, body: formData })
      .then(function (response) {
        return response.json().then(function (data) { return { ok: response.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok || result.data.status) {
          throw new Error(result.data.description || result.data.message || self.strings.addError);
        }
        button.classList.add("is-added");
        self.later(function () { button.classList.remove("is-added"); }, 1600);
        if (status) status.textContent = self.strings.added || "";

        if (typeof window.publish === "function" && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: "eon-drop",
            productVariantId: result.data.variant_id,
            cartData: result.data,
          });
        }

        if (hasDrawer) {
          cartDrawer.renderContents(result.data);
        } else if (result.data.sections && result.data.sections["cart-icon-bubble"]) {
          var bubble = document.getElementById("cart-icon-bubble");
          var html = new DOMParser().parseFromString(result.data.sections["cart-icon-bubble"], "text/html");
          var source = html.querySelector(".shopify-section");
          if (bubble && source) bubble.innerHTML = source.innerHTML;
        }
      })
      .catch(function (error) {
        if (status) status.textContent = (error && error.message) || self.strings.addError || "";
      })
      .then(function () {
        button.classList.remove("is-loading");
      });
  };

  /* ------------------------------------------------------------------------
     Registro / ciclo de vida
     ------------------------------------------------------------------------ */
  function broadcastUnlockAll(origin) {
    document.querySelectorAll("[data-eon-drop-root]").forEach(function (root) {
      if (root === origin || !root.__eonDrop || root.__eonDrop.isGate) return;
      root.classList.add("is-unlocked-all");
      root.__eonDrop.revealAll(true);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll("[data-eon-drop-root]").forEach(function (root) {
      if (!root.__eonDrop) root.__eonDrop = new DropRoot(root);
    });
  }

  function destroyAll(scope) {
    (scope || document).querySelectorAll("[data-eon-drop-root]").forEach(function (root) {
      if (root.__eonDrop) root.__eonDrop.destroy();
    });
  }

  window.EONDrop = { initAll: initAll };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) { initAll(event.target); });
  document.addEventListener("shopify:section:unload", function (event) { destroyAll(event.target); });
})();
